import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { LightningStrikeAnimation } from '../blasts/LightningStrike';

registerCollisionAnimation('LIGHTNING_BOLT', (ctx, e, config, progress) => {
  LightningStrikeAnimation(ctx, e as any, config, progress);
});
